module.exports = __webpack_public_path__ + "static/media/GothamBold.678599da.woff";